import { __awaiter, __generator } from "tslib";
import Vue from 'vue-ltur';
import { SkipToContentComponent } from "static-components";
import { STATE, StateHelper } from "Helper/StateHelper";
var initializeSkipToContent = function (page, consentId) { return __awaiter(void 0, void 0, void 0, function () {
    var mountEl, skipToContentItems_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                mountEl = document.querySelector('c-skip-to-content');
                return [4 /*yield*/, StateHelper.instance.readyStates(STATE.TRANSLATOR)];
            case 1:
                _a.sent();
                if (mountEl) {
                    skipToContentItems_1 = [];
                    switch (page) {
                        case 'homepage':
                            skipToContentItems_1 = [
                                {
                                    label: Vue.translate('skip.to.content.to.search'),
                                    target: 'searchMaskContainer',
                                    focus: 'searchDestination'
                                },
                                {
                                    label: Vue.translate('skip.to.content.to.main.content'),
                                    target: 'c-main-content',
                                    focus: ''
                                }
                            ];
                            break;
                        case 'worldwide':
                            skipToContentItems_1 = [
                                {
                                    label: Vue.translate('skip.to.content.to.search'),
                                    target: 'searchMaskContainer',
                                    focus: 'searchDestination'
                                },
                                {
                                    label: Vue.translate('skip.to.content.to.filter'),
                                    target: 'flyoutFilterbar',
                                    focus: ''
                                },
                                {
                                    label: Vue.translate('skip.to.content.destinations'),
                                    target: 'c-destination-accordion',
                                    focus: ''
                                }
                            ];
                            break;
                        case 'hotellist':
                            skipToContentItems_1 = [
                                {
                                    label: Vue.translate('skip.to.content.to.search'),
                                    target: 'searchMaskContainer',
                                    focus: 'searchDestination'
                                },
                                {
                                    label: Vue.translate('skip.to.content.to.filter'),
                                    target: 'flyoutFilterbar',
                                    focus: ''
                                },
                                {
                                    label: Vue.translate('skip.to.content.hotels'),
                                    target: 'c-hotel-card',
                                    focus: ''
                                }
                            ];
                            break;
                        case 'hoteldetail':
                            skipToContentItems_1 = [
                                {
                                    label: Vue.translate('skip.to.content.to.search'),
                                    target: 'searchMaskContainer',
                                    focus: 'searchDestination'
                                },
                                {
                                    label: Vue.translate('skip.to.content.hoteldetails'),
                                    target: 'detailButton',
                                    focus: 'detailButton'
                                },
                                {
                                    label: Vue.translate('skip.to.content.offers'),
                                    target: 'filter-meta-searcher-wrapper',
                                    focus: ''
                                }
                            ];
                            break;
                        case 'userpage':
                            skipToContentItems_1 = [
                                {
                                    label: Vue.translate('skip.to.content.to.main.content'),
                                    target: 'c-main-content',
                                    focus: ''
                                }
                            ];
                            break;
                        case 'bookmark':
                            skipToContentItems_1 = [
                                {
                                    label: Vue.translate('skip.to.content.to.search'),
                                    target: 'searchMaskContainer',
                                    focus: 'searchDepartureAirport'
                                },
                                {
                                    label: Vue.translate('skip.to.content.to.filter'),
                                    target: 'flyoutFilterbar',
                                    focus: ''
                                },
                                {
                                    label: Vue.translate('skip.to.content.to.main.content'),
                                    target: 'container-h',
                                    focus: ''
                                }
                            ];
                            break;
                    }
                    new Vue({
                        props: ['items', 'consentId'],
                        render: function (createElement) {
                            var context = {
                                props: {
                                    items: skipToContentItems_1,
                                    consentId: consentId
                                },
                            };
                            return createElement(SkipToContentComponent, context);
                        }
                    }).$mount('c-skip-to-content');
                }
                return [2 /*return*/];
        }
    });
}); };
export default initializeSkipToContent;
